import React from 'react';
import PropTypes from 'prop-types';

import { Background } from './styles';
import { Loader } from '../Button/styles';

export default function LoadingFullScreen({ active, backgroundFull }) {
  return (
    <Background active={active} backgroundFull={backgroundFull}>
      <Loader variant="ghost" />
    </Background>
  );
}

LoadingFullScreen.propTypes = {
  active: PropTypes.bool,
};

LoadingFullScreen.defaultProps = {
  active: false,
};
